const ISBN_10_REGEX = /^([0-9]{9})[0-9xX]$/;
const ISBN_13_REGEX = /^([0-9]{12})[0-9xX]$/;

export function cleanupIsbn(isbn: string): string | undefined {
  const matches = isbn.match(/([0-9Xx\s\-]*)/);
  if (matches && matches.length >= 2) {
    const cleanedIsbn = matches[1].replace(/([^0-9Xx]*)/g, '');
    if (isCleanedIsbn10(cleanedIsbn) || isCleanedIsbn13(cleanedIsbn)) {
      return cleanedIsbn.toUpperCase();
    }
  }

  return undefined;
}

export function isbnsToUniqueIsbn13s(isbns: string[]): string[] {
  const isbn13s = isbns
    .map(isbn => {
      if (isIsbn13(isbn)) {
        return cleanupIsbn(isbn);
      } else if (isIsbn10(isbn)) {
        return isbn10ToIsbn13(isbn);
      }

      return undefined;
    })
    .filter(isbn => Boolean(isbn));

  return [...new Set(isbn13s)];
}

export function isbn10ToIsbn13(isbn10: string): string | undefined {
  const cleanedIsbn10 = cleanupIsbn(isbn10);
  if (isCleanedIsbn10(cleanedIsbn10)) {
    const [, firstNineDigits] = cleanedIsbn10.match(ISBN_10_REGEX);
    const prefixedIsbn10 = `978${firstNineDigits}`;
    const checkDigit = computeCheckDigitIsbn13(prefixedIsbn10);
    return `${prefixedIsbn10}${checkDigit}`;
  }

  return undefined;
}

export function computeCheckDigitIsbn13(isbn13?: string): number | undefined {
  if (isbn13) {
    const chars = isbn13.split('');

    // sum digits, alternating multipliers of 1 (even) and 3 (odd)
    const sumOfDigits = chars.reduce((sum, char, i) => {
      const digit = Number(char);
      const multiplier = isEven(i) ? 1 : 3;
      return sum + digit * multiplier;
    }, 0);

    // divide the sumOfDigits by the modulus number (10) to find the remainder
    // and then minus 10 to get the check digit
    return (10 - (sumOfDigits % 10)) % 10;
  }

  return undefined;
}

export function isIsbn10(isbn: string): boolean {
  return isCleanedIsbn10(cleanupIsbn(isbn));
}

export function isCleanedIsbn10(cleanedIsbn10: string): boolean {
  return Boolean(cleanedIsbn10) && ISBN_10_REGEX.test(cleanedIsbn10);
}

export function isIsbn13(isbn: string): boolean {
  return isCleanedIsbn13(cleanupIsbn(isbn));
}

export function isCleanedIsbn13(cleanedIsbn13: string): boolean {
  return Boolean(cleanedIsbn13) && ISBN_13_REGEX.test(cleanedIsbn13);
}

function isEven(value: number): boolean {
  return value % 2 === 0;
}
